<script lang="ts">
  // Mobile bottom bar (spec §3): Inbox (badge = inbox unseen), Folders, Contacts, Settings.
  import { badgeText, t } from '$lib/i18n';
  import { inboxPath } from '$lib/mail/folders';
  import { store } from '$lib/store';
  import Icon from '../ui/Icon.svelte';

  const inbox = $derived(inboxPath(store.folders));
  const unseen = $derived(store.folders.find((f) => f.path === inbox)?.unseen ?? 0);
  const onInbox = $derived(store.screen.name === 'list' && store.currentFolder === inbox);
</script>

<nav class="tabbar mobile-only" aria-label={t('folders')}>
  <button type="button" class="tab" class:on={onInbox} aria-current={onInbox ? 'page' : undefined} onclick={() => void store.openFolder(inbox)}>
    <span class="tab-ic"><Icon name="inbox" size={22} />{#if unseen}<span class="tab-badge">{badgeText(unseen)}</span>{/if}</span>
    <span>{t('inbox')}</span>
  </button>
  <button type="button" class="tab" onclick={() => (store.foldersSheet = true)}>
    <span class="tab-ic"><Icon name="folder" size={22} /></span>
    <span>{t('folders')}</span>
  </button>
  <button type="button" class="tab" onclick={() => store.openContacts()}>
    <span class="tab-ic"><Icon name="users" size={22} /></span>
    <span>{t('contacts')}</span>
  </button>
  <button type="button" class="tab" onclick={() => store.openSettings()}>
    <span class="tab-ic"><Icon name="gear" size={22} /></span>
    <span>{t('settings')}</span>
  </button>
</nav>

<style>
  /* @css shell/TabBar start */
  nav:not(.tabbar) {
    flex: 1;
    display: grid;
    gap: var(--space-1);
    align-content: start
  }

  .tabbar {
    position: fixed;
    inset-inline: 0;
    bottom: 0;
    display: none;
    min-block-size: var(--tabbar-h);
    background: var(--surface-card);
    border-top: 1px solid var(--border-subtle);
    padding-bottom: env(safe-area-inset-bottom);
    z-index: var(--z-nav)
  }

  .tab {
    flex: 1;
    display: grid;
    justify-items: center;
    gap: var(--space-1);
    padding: var(--space-2) 0;
    font-size: var(--text-eyebrow);
    color: var(--text-muted)
  }

  .tab.on {
    color: var(--text-link);
    font-weight: var(--weight-semibold)
  }

  .tab-ic {
    position: relative;
    display: grid
  }

  .tab-badge {
    position: absolute;
    top: -4px;
    inset-inline-end: -10px;
    background: var(--blue-500);
    color: var(--text-on-accent);
    border-radius: var(--radius-pill);
    font-size: var(--text-eyebrow);
    padding: 0 var(--space-1);
    min-width: 16px;
    text-align: center
  }

  .tab:active {
    background: var(--mail-pressed)
  }

  .mobile-only {
    display: none
  }

  @media (max-width:900px) {
  button.mobile-only {
      display: inline-grid
    }
  }

  @media (max-width:900px) {
  .tabbar.mobile-only {
      display: flex
    }
  }

  .tabbar {
    padding-inline: env(safe-area-inset-left) env(safe-area-inset-right)
  }
  /* @css shell/TabBar end */
</style>
